// Generated by script, don't edit it please.
import createSvgIcon from '../../createSvgIcon';
import StarSvg from '@rsuite/icon-font/lib/legacy/Star';
var Star = createSvgIcon({
    as: StarSvg,
    ariaLabel: 'star',
    category: 'legacy',
    displayName: 'Star'
});
export default Star;
